module.exports = __webpack_public_path__ + "static/img/Y1D200.5147d98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Y1D200.png
// module id = USMk
// module chunks = 2